import RestService from '../services/rest';

async function getLeadTimes(limit, skip, search, order = '', field = '') {
  return RestService.getAuthenticated(
    `panel/leadTime?limit=${limit}&skip=${skip}&search=${search}&order=${order}&field=${field}`,
  );
}

async function getLeadTime(id) {
  return RestService.getAuthenticated(`panel/leadTime/${id}`);
}

async function createLeadTime(leadTime) {
  return RestService.postAuthenticated('panel/leadTime/create', leadTime);
}

async function updateLeadTime(leadTime) {
  return RestService.putAuthenticated('panel/leadTime/update', leadTime);
}

async function deleteLeadTime(id) {
  return RestService.postAuthenticated('panel/leadTime/delete', { id });
}

export default {
  getLeadTimes,
  getLeadTime,
  createLeadTime,
  updateLeadTime,
  deleteLeadTime,
};
